import React, { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";
import { AuthContext } from "../helpers/AuthContext";


function AddToolsGroup() {
  let navigate = useNavigate();
  const { authState } = useContext(AuthContext);
  const initialValues = {
    groupname: "",
    storagePositions: "",
    isClothing: false
  };

  const [apiUrl, setApiUrl] = useState("");
  const [loadingConfig, setLoadingConfig] = useState(true);

  React.useEffect(() => {
    async function fetchConfig() {
      const config = await loadConfig();
      setApiUrl(config.APIURL);
      setLoadingConfig(false);
    }
    fetchConfig();
  }, []);

  const validationSchema = Yup.object().shape({
    groupname: Yup.string().required("You must input a groupname!"),
    storagePositions: Yup.string(),
  });

  const onSubmit = async (data) => {
    // Convert storagePositions to array
    const storagePositionsArr = data.storagePositions
      ? data.storagePositions.split(",").map(opt => opt.trim()).filter(opt => opt)
      : [];
    const payload = {
      ...data,
      storagePositions: storagePositionsArr
    };
    await axios.post(`${apiUrl}/toolsgroups`, payload, {
      headers: { accessToken: localStorage.getItem("accessToken") }
    });
    navigate("/toolsgroups");
  };

  if (loadingConfig) {
    return <LoadingSpinner text="Lade Konfiguration..." />;
  }

  if (!authState.isAdmin) {
    return (
      <div className="container" style={{ marginTop: '100px', textAlign: 'center' }}>
        <h2>⚠️ Zugriff verweigert</h2>
        <p>Nur Administratoren können Gerätegruppen hinzufügen.</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">Neue Gerätegruppe hinzufügen</div>
        <div className="card-body">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            <Form>
              <div className="form-group">
                <label htmlFor="groupname">Gruppenname:</label>
                <Field
                  id="groupname"
                  name="groupname"
                  placeholder="(Ex. C-Schlauch...)"
                  className="form-control"
                />
                <ErrorMessage name="groupname" component="span" className="error-message" />
              </div>


              <div className="form-group">
                <label htmlFor="storagePositions">Lagerort Optionen (Komma getrennt):</label>
                <Field
                  id="storagePositions"
                  name="storagePositions"
                  placeholder="z.B. Regal 1, Regal 2, Fach B"
                  className="form-control"
                />
                <ErrorMessage name="storagePositions" component="span" className="error-message" />
              </div>

              <div className="form-group form-check">
                <Field
                  id="isClothing"
                  name="isClothing"
                  type="checkbox"
                  className="form-check-input"
                />
                <label htmlFor="isClothing" className="form-check-label">
                  Kleidungsgruppe (Geräte dieser Gruppe können eine Waschhistorie führen)
                </label>
              </div>

              <button type="submit" className="btn btn-primary">Hinzufügen</button>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default AddToolsGroup;
